var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoseImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264,1152h752c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H264c-4.4,0-8-3.6-8-8v-48C256,1155.6,259.6,1152,264,1152z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264,64h752c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H264c-4.4,0-8-3.6-8-8V72C256,67.6,259.6,64,264,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1136,320h-48V208c0-8.8-7.2-16-16-16H208c-8.8,0-16,7.2-16,16v112h-48c-8.8,0-16,7.2-16,16v608 c0,8.8,7.2,16,16,16h48v112c0,8.8,7.2,16,16,16h864c8.8,0,16-7.2,16-16V960h48c8.8,0,16-7.2,16-16V336 C1152,327.2,1144.8,320,1136,320z M256,256h768v64H256V256z M192,767.1l365.1-211.8L766.7,896H192V767.1z M1024,1024H256v-64h768 V1024z M1088,896H841.9l-77.3-125.6L1088,622.2V896z M1088,551.8L730.8,715.5L578.9,468.7L192,693.1V384h896V551.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoseImageNormal);
export default __webpack_public_path__ + "static/media/pose_image_normal.ad27a431c7bffcb28856166864a66535.svg";
export { ForwardRef as ReactComponent };